import { setContext } from "@apollo/client/link/context";
import useServerEnv from "@magalu/rave/config/useServerEnv";

interface ChannelConfig {
  id: string;
  name: string;
}

interface ClientConfig {
  channel: {
    desktop: ChannelConfig;
    mobile: ChannelConfig;
  };
}

export const channelConfig = setContext(() => {
  try {
    const { client } = useServerEnv<object, ClientConfig>();

    return {
      configEnv: {
        channel: {
          desktop: {
            id: client?.channel?.desktop?.id,
            name: client?.channel?.desktop?.name,
          },
          mobile: {
            id: client?.channel?.mobile?.id,
            name: client?.channel?.mobile?.name,
          },
        },
      },
    };
  } catch (_error) {
    return {
      configEnv: {
        channel: {
          desktop: {
            id: "45",
            name: "mixer-desk.magazineluiza.com.br",
          },
          mobile: {
            id: "9",
            name: "mixer.magazineluiza.com.br",
          },
        },
      },
    };
  }
});
